// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main[data-v-9b72aa4a]{flex-direction:row}.page-layout-new[data-v-9b72aa4a]{min-height:100vh;display:flex;flex-direction:column;background:#f9f9f9}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
